module.exports = __webpack_public_path__ + "img/f-thermometer-img8-3.5c5ef66f.png";